<template>
  <h1 class="text-center py-5">Política de Privacidad y Condiciones del Servicio</h1>
  <div class="container-fluid">
    <p>&Uacute;ltima actualizaci&oacute;n: [18 de mayo de 2025]</p>
    <p>Bienvenido a Subslot. Esta Pol&iacute;tica de Privacidad y Condiciones del Servicio explica c&oacute;mo recopilamos, utilizamos y protegemos tus datos, y cu&aacute;les son las reglas de uso de nuestra plataforma.</p>
    <h2>1. Informaci&oacute;n General</h2>
    <p>Subslot es una plataforma digital que permite a los usuarios compartir suscripciones de servicios de streaming y otras plataformas digitales de forma organizada, legal y responsable. El acceso est&aacute; limitado a la gesti&oacute;n y organizaci&oacute;n de grupos compartidos de suscripci&oacute;n.</p>
    <h2>2. Registro y Autenticaci&oacute;n</h2>
    <p>Para utilizar nuestros servicios, puedes registrarte mediante:</p>
    <ul>
    <li>Correo electr&oacute;nico y contrase&ntilde;a</li>
    <li>Inicio de sesi&oacute;n con Google o Microsoft (OAuth 2.0)</li>
    <li>Inicio de sesi&oacute;n con billeteras blockchain compatibles con Sui o Solana</li>
    </ul>
    <p>En todos los casos, almacenamos &uacute;nicamente la informaci&oacute;n m&iacute;nima necesaria para brindarte el servicio, como tu ID de usuario, nombre y correo electr&oacute;nico. No almacenamos contrase&ntilde;as de terceros ni claves privadas.</p>
    <h2>3. Datos que Recopilamos</h2>
    <ul>
    <li>Datos personales: nombre, correo electr&oacute;nico, pa&iacute;s de residencia</li>
    <li>Actividad en la plataforma: suscripciones activas, grupos a los que perteneces, renovaciones, historial de movimientos</li>
    <li>Datos t&eacute;cnicos: direcci&oacute;n IP, tipo de dispositivo, navegador</li>
    <li>En caso de billeteras, tu direcci&oacute;n p&uacute;blica en la red Sui o Solana</li>
    </ul>
    <h2>4. Uso de los Datos</h2>
    <p>Utilizamos tu informaci&oacute;n para:</p>
    <ul>
    <li>Brindar acceso a los grupos de suscripci&oacute;n</li>
    <li>Mostrar contenido personalizado (plataformas disponibles, recomendaciones)</li>
    <li>Facilitar pagos y renovaciones entre los miembros del grupo</li>
    <li>Notificarte sobre vencimientos o cambios en tus grupos</li>
    <li>Mejorar la experiencia de usuario</li>
    <li>Realizar auditor&iacute;a y trazabilidad de acciones (logs internos)</li>
    </ul>
    <h2>5. Privacidad y Seguridad</h2>
    <ul>
    <li>Tus datos no son compartidos con terceros, salvo cuando sea necesario para proveer el servicio (por ejemplo, pasarelas de pago)</li>
    <li>Cumplimos con las normativas de protecci&oacute;n de datos aplicables en Latinoam&eacute;rica</li>
    <li>Ciframos los datos sensibles en tr&aacute;nsito y en reposo</li>
    <li>No almacenamos contrase&ntilde;as de plataformas de streaming; solo las asociamos a nivel de grupo encriptado con fines de uso interno</li>
    </ul>
    <h2>6. Condiciones del Servicio</h2>
    <ul>
    <li>Al unirte a un grupo, aceptas respetar las reglas internas de uso compartido</li>
    <li>La duraci&oacute;n de las suscripciones es variable, y puede ajustarse seg&uacute;n la disponibilidad y comportamiento del grupo</li>
    <li>El sistema puede redistribuir perfiles disponibles para optimizar costos y evitar desperdicio de suscripciones</li>
    <li>Subslot no ofrece acceso directo a plataformas de terceros, solo organiza el uso compartido de cuentas bajo responsabilidad del usuario administrador del grupo</li>
    </ul>
    <h2>7. Pagos y Renovaciones</h2>
    <ul>
    <li>El costo por perfil se calcula autom&aacute;ticamente seg&uacute;n la duraci&oacute;n y el costo del grupo</li>
    <li>Puedes ver claramente la fecha de expiraci&oacute;n del grupo y decidir si renovar</li>
    <li>En caso de no renovaci&oacute;n, tu lugar puede ser reasignado a otro usuario para maximizar la eficiencia del grupo</li>
    <li>No se emiten facturas tributarias autom&aacute;ticas; almacenamos tu historial de pagos y movimientos con fines informativos</li>
    </ul>
    <h2>8. Wallets y Web3</h2>
    <ul>
    <li>Si decides ingresar con una wallet compatible, tu identidad se basa en la firma de un mensaje y tu direcci&oacute;n p&uacute;blica</li>
    <li>No almacenamos tus claves privadas</li>
    <li>En el futuro podr&iacute;amos ofrecer beneficios o integraciones adicionales vinculadas a Web3, respetando siempre tu privacidad</li>
    </ul>
    <h2>9. Derechos del Usuario</h2>
    <p>Tienes derecho a:</p>
    <ul>
    <li>Acceder, rectificar o eliminar tus datos personales</li>
    <li>Solicitar informaci&oacute;n sobre c&oacute;mo se usan tus datos</li>
    <li>Cerrar tu cuenta y eliminar toda tu informaci&oacute;n</li>
    <li>Puedes ejercer estos derechos escribi&eacute;ndonos a: <a title="Correo de contacto" href="mailto:me@rho1and0.net">me@rho1and0.net</a>&nbsp;detallando el asunto relacionados a los puntos anteriores.</li>
    </ul>
    <h2>10. Cambios en esta Pol&iacute;tica</h2>
    <p>Subslot se reserva el derecho de actualizar esta pol&iacute;tica en cualquier momento. En caso de cambios importantes, te notificaremos por correo electr&oacute;nico o en el sitio web.</p>
    <h2>11. Contacto</h2>
    <p>Si tienes dudas sobre esta pol&iacute;tica o necesitas soporte, cont&aacute;ctanos en:</p>
    <p>Email: <a title="Correo de contacto" href="mailto:me@rho1and0.net">me@rho1and0.net</a><br />Sitio web: <a title="Sitio web" href="https://subslot.rho1and0.net">https://subslot.rho1and0.net</a></p>
    <p>Subslot es un producto de Rho1and0.net Soluciones Software</p>
  </div>
</template>